import { render, staticRenderFns } from "./CgOrderData.vue?vue&type=template&id=7a8fc259&scoped=true"
import script from "./CgOrderData.vue?vue&type=script&lang=js"
export * from "./CgOrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fc259",
  null
  
)

export default component.exports